// src/components/cart/CartItem.jsx
import React from 'react';
import { useCart } from '../../hooks/useCart';

const CartItem = ({ item }) => {
  const { updateQuantity, removeFromCart } = useCart();

  return (
    <div className="cart-item">
      <div className="cart-item-image">
        <img src={item.imageUrl || '/placeholder-book.jpg'} alt={item.title} />
      </div>

      <div className="cart-item-details">
        <h3 className="cart-item-title">{item.title}</h3>
        <p className="cart-item-author">by {item.author}</p>
        <p className="cart-item-price">${item.price.toFixed(2)} CAD each</p>
      </div>

      <div className="cart-item-quantity">
        <label>Quantity</label>
        <input
          type="number"
          min="1"
          value={item.quantity}
          onChange={(e) => updateQuantity(item.id, parseInt(e.target.value) || 1)}
          className="quantity-input"
        />
      </div>

      <div className="cart-item-total">
        <p className="item-total-price">
          ${(item.price * item.quantity).toFixed(2)}
        </p>
      </div>

      <button
        onClick={() => removeFromCart(item.id)}
        className="cart-item-remove-btn"
        aria-label="Remove item"
      >
        ×
      </button>
    </div>
  );
};

export default CartItem;